module.exports = require("@swa-ui/core/src/FocusContainer/focusContainer.module.scss");